import { render, staticRenderFns } from "./facultysixth.vue?vue&type=template&id=84e6c6a8&scoped=true"
import script from "./facultysixth.vue?vue&type=script&lang=js"
export * from "./facultysixth.vue?vue&type=script&lang=js"
import style0 from "./facultysixth.vue?vue&type=style&index=0&id=84e6c6a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84e6c6a8",
  null
  
)

export default component.exports